/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getTelemetryObject, IModuleProps, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IContentBlockWithSelectorProps } from './content-block-with-selector.props.autogenerated';

export interface IContentBlockWithSelectorData {}

export interface IContentBlockWithSelectorViewProps extends IContentBlockWithSelectorProps<IContentBlockWithSelectorData> {
    closeAnimation: string;
    container: IModuleProps;
    telemetryContent: ITelemetryContent;
}

/**
 *
 * ContentBlockWithSelectorModule component.
 * @extends {React.PureComponent<IContentBlockWithSelectorProps<IContentBlockWithSelectorData>>}
 */
class ContentBlockWithSelectorModule extends React.PureComponent<IContentBlockWithSelectorProps<IContentBlockWithSelectorData>> {
    private readonly telemetryContent: ITelemetryContent;

    constructor(props: IContentBlockWithSelectorProps<IContentBlockWithSelectorData>) {
        super(props);
        this.telemetryContent = getTelemetryObject(
            this.props.context.request.telemetryPageName!,
            this.props.friendlyName,
            this.props.telemetry
        );
    }

    public render(): JSX.Element | null {
        const { className } = this.props.config;

        const viewProps = {
            // Context for telemetry and raw data for C1 to do customization
            // Including computed data, state data and methods
            ...this.props,
            telemetryContent: this.telemetryContent,
            container: {
                moduleProps: this.props,
                className: classnames('content-block-with-selector', className)
            }
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default ContentBlockWithSelectorModule;
